<template>
  <span
    class="toggle-switch"
    :class="[
      props.active && 'toggle-switch--active',
      props.disabled && 'toggle-switch--disabled',
    ]"
    role="checkbox"
  >
    <span
      class="toggle-switch__slider"
      :class="[
        props.active && 'toggle-switch__slider--active',
        props.disabled && 'toggle-switch__slider--disabled',
      ]"
    >
      <PhCheck v-if="props.active" size="12" />
      <PhX v-else size="12" />
    </span>
  </span>
</template>

<script lang="ts" setup>
import { PhCheck, PhX } from '@phosphor-icons/vue'

const props = defineProps<{
  active: boolean
  disabled?: boolean
}>()
</script>

<style lang="scss" scoped>
@use 'sass:color';

@use '@/styles/globals';
@use '../../Common/scss/focus';

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  border-radius: 24px;
  border: 1px solid var(--divider);
  background-color: var(--background-secondary);

  transition: globals.transitionOne(background-color),
    globals.transitionOne(opacity);

  &:hover:not(.toggle-switch--disabled) {
    background-color: var(--background-active);
  }

  @include globals.control-shadow();

  &--active {
    background-color: var(--misc-brand);
    border-color: var(--misc-brand);

    &:hover:not(.toggle-switch--disabled) {
      background-color: var(--misc-brand);
      opacity: 0.9;
    }
  }

  &--disabled {
    opacity: 0.6;
    cursor: default;
  }

  &__slider {
    position: absolute;
    top: -1px;
    left: -1px;
    cursor: pointer;
    background-color: var(--background-primary);
    height: 24px;
    width: 24px;
    border-radius: 12px;
    border: 1px solid var(--divider);
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--divider);

    transition: transform 72ms ease-in-out;

    @include globals.control-shadow();

    &--active {
      // Technically this should be 18px, but with the dark bg
      // 18 creates clipping artifacts
      transform: translateX(19px);
      color: var(--misc-brand);
    }

    &--disabled {
      cursor: default;
      opacity: 0.6;
    }
  }
}
</style>
